module.exports = __webpack_public_path__ + "static/media/machine_interaction.991135a6.svg";